/*
* Created on Feb 23, 2021
* @author: Adam Cheng <adamcheng@qnap.com>
*/
import {useEffect, useState, useRef} from 'react';
// import {Map, APILoader, Marker} from '@uiw/react-baidu-map';
import { asyncWrapper, BaiduMap, Marker, GeolocationControl, NavigationControl } from 'react-baidu-maps';
import axios from "axios";


const SiteBaiduMapComponent = ({input, setInput, bMap, setBMap}) => {
    const AsyncMap = asyncWrapper(BaiduMap);

    const [latlng, setLatLng] = useState({lat: null, lng: null})

    const onAPILoad = () => {
        // eslint-disable-next-line no-undef
        setBMap(BMap);
    }

    const getCurrentGeoLocation = (e) => {
        if (typeof bMap !== 'undefined' && bMap !== null) {
            console.log(bMap);
            const geo = new bMap.Geolocation();
            geo.enableSDKLocation();
            if (input?.location?.value?.address) {
                setLatLng({lat: input?.location.value.lat, lng: input?.location.value.lng})
            }
            else {
                geo.getCurrentPosition((resp)=>{
                    console.log(resp)
                    setLatLng({lat: resp?.latitude, lng: resp?.longitude})
                });
            }
            // const myCity = new bMap.LocalCity();
            // myCity.get((data)=>{
            //     console.log({lat: data?.center.lat, lng: data.center.lng});
            //     setLatLng({lat: data?.center.lat, lng: data?.center.lng})
            // });
        }

    }

    const onChangeLocation = (e) => {
        if (bMap) {
            const geo = new bMap.Geocoder();
            geo.getLocation(e.point, (resp)=>{
                console.log(resp);
                setInput((prevInput) => {
                    return {...prevInput, location: {value: {lat: e.point.lat, lng: e.point.lng, address: resp.address}}}
                });
                setLatLng({lat: e.point.lat, lng: e.point.lng});
            });
        }
        // axios.get(`https://api.map.baidu.com/geocoder/v2/?location=${lng},${lat}&key=${process.env.REACT_APP_BAIDU_MAP_AK}&output=json`)
        //     .then((data)=>{
        //         console.log(data);
        //         setInput((prevInput) => {
        //             return {...prevInput, location: {value: {lat: lat(), lng: lng(), address: data.data.results?.[0].formatted_address}}}
        //         });
        //     });
    }

    useEffect(()=>{
        getCurrentGeoLocation();
    }, [bMap, input?.location?.value])

    return (

        <>
            <AsyncMap
                zoom={14}
                center={{lng: latlng.lng, lat: latlng.lat}}
                onClick={(e)=>console.log(e)}
                onRightclick={(e)=>onChangeLocation(e)}
                mapUrl={`https://api.map.baidu.com/api?v=3.0&ak=${window._env_.REACT_APP_BAIDU_MAP_AK}`}
                loadingElement={<div>Loading.....</div>}
                mapContainer={<div style={{height: '100%'}}/>}
                onMapSrcLoaded={onAPILoad}
                >
                <Marker position={{lng: latlng.lng || input?.location.value.lng, lat: latlng.lat || input?.location.value.lat}}/>
                <NavigationControl
                    type="small"
                    anchor="top_left"/>
            </AsyncMap>
        </>
    );
};

export default SiteBaiduMapComponent;